import type React from 'react';
import { Route, Routes } from 'react-router-dom';
import { CoachVideoPage } from '@pages/coaches/CoachVideoPage';
import { EditorCoach } from './editor-page';
import { ProfileCoach } from './profile-page';

export const PersonalCoach: React.FC = () => {
  return (
    <Routes>
      <Route index element={<ProfileCoach />} />
      <Route path="edit" element={<EditorCoach />} />
      <Route path=":coachVideoId" element={<CoachVideoPage />} />
    </Routes>
  );
};
